<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="card-plain">
            <template slot="header">
              <h4 class="card-title">Welcome Back {{ user && user.name || '...' }}</h4>
              <p class="card-category">Below are your Profile details</p>
            </template>
            <p v-if="loading" class="card-category">Loading Profile...</p>
            <p v-else-if="!user || !user.name" class="card-category">No Profile found...</p>
          </card>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <edit-profile-form :user="user" v-if="user && user.name" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import EditProfileForm from './UserProfile/EditProfileForm.vue'
  import Card from 'src/components/Cards/Card.vue'

  import { getApp } from 'firebase/app';
  import { getFunctions, httpsCallable, connectFunctionsEmulator } from "firebase/functions";

  export default {
    components: {
      EditProfileForm,
      Card
    },
    data () {
      return {
        user: '',
        loading: false,
      }
    },
    async created () {
      try {
        this.loading = true
        const app = getApp()
        const functions = getFunctions(app, 'europe-west1')
        // connectFunctionsEmulator(functions, "127.0.0.1", 5001);
        await this.getUser(functions)
      } catch (error) {
        alert('Error querying API. Error: ' + error)
      } finally {
        this.loading = false
      }
    },
    methods: {
      async getUser(functions) {
        try {
          const getUser = httpsCallable(functions, 'getUser');
          const getUserRes = await getUser()
          this.user = getUserRes.data.data
        } catch (error) {
          alert('Error getting User. Error: ' + error)
        }
      },
    }
  }

</script>
<style>

</style>
